<template>
 <q-page class="flex flex-center">
  <div class="q-pa-md">

    <div class="row">
    <div class="col-12" align="center">
    <img alt="Quasar logo" src="../../assets/img/404.svg">
    </div>
      <div class="col-12" align="center">
       <div class="text-h1">404</div>
      </div>
      <div class="col-12" align="center">
       <div class="text-h4">La URL solicitada no se encontró en este servidor</div>
      </div>
      <div class="col-12" align="center">
        <div class="text-subtitle2">Esto es muy vergonzoso, esperemos que no vuelva a pasar.</div>
      </div>
      <div class="col-12" align="center">
        <div class="q-pa-md q-gutter-sm">
            <q-btn color="primary" icon="home" label="Regresar a inicio" to="/" v-if="valUser.IsLogged"/>
            <q-btn color="primary" icon="login" label="Iniciar Sesión" to="/cuenta/login" v-if="!valUser.IsLogged"/>
            <q-btn color="secondary" icon="mail" label="Contáctanos" type="a" href="mailto:jadriano@haciendachiapas.gob.mx?cc=fpazm@haciendachiapas.gob.mx&subject=[Error]%20SICOPE"/>
        </div>
      </div>
    </div>

  </div>
  </q-page>


 
</template>

<script>
import {mapState} from 'vuex';




export default {

   computed:{
            ...mapState(['user']),
            valUser(){
              return this.user
            }
        },
}

</script>

